<template>
    <template v-if="!cannedStatus">
        <div
            class="p-4 h-full transition-none"
            id="send_box"
            :class="[
                openType ? 'full-container' : 'shrunk_anim rounded-lg',
                selectedDropdownOption === 'note' ? 'note-container' : 'bg-gray-100',
                selectedDropdownOption === 'email' ? 'email-container' : '',
            ]"
        >
            <div class="box-container h-full" :class="[openType ? '!max-h-full' : '']">
                <div
                    class="w-full flex-grow flex rounded overflow-y-auto h-full"
                    :class="[
                        selectedDropdownOption === 'note' ? 'bg-transparent' : 'bg-gray-100',
                        !toPreview ? 'flex-col' : '',
                    ]"
                >
                    <div v-if="!toPreview" class="mode">
                        <div class="select_mode h-[17px] !leading-[17px] flex">
                            <div class="flex items-center gap-4">
                                <VDropdown
                                    placement="bottom-start"
                                    auto-boundary-max-size
                                    :prevent-overflow="true"
                                    :overflow-padding="10"
                                >
                                    <div class="flex items-center gap-1">
                                        <span class="cursor-pointer capitalize">{{ selectedDropdownOption }}</span>
                                        <fa
                                            :icon="['fas', 'chevron-down']"
                                            class="text-[10px] leading-normal text-black-600 cursor-pointer"
                                        />
                                    </div>

                                    <template #popper="{ hide }">
                                        <ul class="p-4">
                                            <li
                                                v-for="(option, index) in dropdownOptions.filter(
                                                    (option) => option.value !== selectedDropdownOption,
                                                )"
                                                class="text-dark-100 italic text-sm flex p-2 rounded-lg items-center cursor-pointer hover:bg-gray-100"
                                                @click="(handleOptionClick(option.value), hide())"
                                            >
                                                <fa
                                                    :icon="['fal', option.icon]"
                                                    class="text-gray-navtext mr-1 text-lg"
                                                />
                                                {{ option.label }}
                                            </li>
                                        </ul>
                                    </template>
                                </VDropdown>
                                <div v-show="isShowJoditOptions" class="absolute top-1 left-[5.5rem]">
                                    <JoditOptions
                                        @handleStyle="(style) => handleStyles(style)"
                                        :activeStates="optionsActiveState"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="flex items-center gap-2">
                            <div
                                v-if="messageAttachments.length"
                                @click="() => (messageAttachments = [])"
                                class="cursor-pointer"
                            >
                                <p class="text-xs text-blue-500 underline">Clear all</p>
                            </div>
                            <fa
                                :icon="[
                                    'fal',
                                    openType
                                        ? 'arrow-down-left-and-arrow-up-right-to-center'
                                        : 'arrow-up-right-and-arrow-down-left-from-center',
                                ]"
                                class="!text-sm !text-gray-300 cursor-pointer"
                                @click="toggleFullType"
                            />
                        </div>
                    </div>
                    <div class="message_area pt-4 flex w-full flex-grow items-center overflow-y-auto h-full">
                        <!-- :class="[!toPreview ? 'pt-4' : '']" -->
                        <div class="w-full h-full overflow-y-auto hide_scroll !block">
                            <div v-if="messageAttachments.length" class="flex flex-col overflow-y-auto h-full">
                                <div
                                    class="flex items-start flex-wrap gap-4 w-full h-full p-4"
                                    v-if="messageAttachmentsByType.images.length"
                                >
                                    <div
                                        v-for="(attachment, index) in messageAttachmentsByType.images"
                                        :key="index"
                                        class="relative w-[12rem] cursor-pointer transition-all duration-300 rounded-lg"
                                    >
                                        <div
                                            class="w-5 h-5 rounded-full flex items-center justify-center bg-slate-50 border border-gray-100 absolute top-0 right-0 translate-x-1/2 -translate-y-1/2"
                                            @click="() => handleRemoveAttachment(index)"
                                        >
                                            <fa class="text-xs cursor-pointer" :icon="['fal', 'close']"></fa>
                                        </div>
                                        <img
                                            :src="attachment.url"
                                            class="w-full h-20 object-cover shadow-sm rounded-lg"
                                        />
                                    </div>
                                </div>

                                <div
                                    class="flex items-center flex-wrap gap-4 w-full h-full p-4"
                                    v-if="messageAttachmentsByType.documents.length"
                                >
                                    <div
                                        v-for="(attachment, index) in messageAttachmentsByType.documents"
                                        :key="index"
                                        class="relative border border-transparent hover:border-black-500 p-0.5 px-4 cursor-pointer transition-all duration-300 rounded-lg"
                                    >
                                        <div
                                            class="w-5 h-5 rounded-full flex items-center justify-center bg-slate-50 border border-gray-100 absolute top-0 right-0 translate-x-1/2 -translate-y-1/2"
                                            @click="() => handleRemoveAttachment(index)"
                                        >
                                            <fa class="text-xs cursor-pointer" :icon="['fal', 'close']"></fa>
                                        </div>
                                        <a
                                            class="decoration-none items-center text-sm flex gap-2 h-auto w-auto text-black-100"
                                            :href="attachment.url"
                                        >
                                            <fa
                                                class="h-6"
                                                :class="
                                                    fileIcon[getFileType(attachment.file.name)].includes('file-word')
                                                        ? 'text-[#0744C2]'
                                                        : fileIcon[getFileType(attachment.file.name)].includes(
                                                                'file-pdf',
                                                            )
                                                          ? 'text-red-300'
                                                          : 'text-green-600     '
                                                "
                                                :icon="fileIcon[getFileType(attachment.file.name)]"
                                            />

                                            <div>
                                                <span class="text-ellipsis overflow-hidden block max-w-[210px]">
                                                    {{ attachment.file.name }}
                                                </span>
                                                <p class="flex items-center gap-1 text-gray-400 text-xs">
                                                    {{ formatFileSize(attachment.file.size) }}
                                                    <fa class="h-2" :icon="['fas', 'circle']" />
                                                    {{ getFileType(attachment.file.name) }}
                                                </p>
                                            </div>
                                        </a>
                                    </div>
                                </div>

                                <div
                                    class="flex items-center flex-wrap gap-4 w-full h-full p-4"
                                    v-if="messageAttachmentsByType.videos.length"
                                >
                                    <div
                                        v-for="(attachment, index) in messageAttachmentsByType.videos"
                                        :key="index"
                                        class="relative cursor-pointer transition-all duration-300 rounded-lg min-w-[10rem]"
                                    >
                                        <div
                                            class="w-5 h-5 rounded-full flex items-center justify-center bg-slate-50 border border-gray-100 absolute top-0 right-0 translate-x-1/2 -translate-y-1/2"
                                            @click="() => handleRemoveAttachment(index)"
                                        >
                                            <fa class="text-xs cursor-pointer" :icon="['fal', 'close']"></fa>
                                        </div>
                                        <video
                                            width="320"
                                            height="240"
                                            controls
                                            class="bg-gray-100 rounded-xl rounded-tl-none text-sm mb-2 h-40 w-full"
                                        >
                                            <source :src="attachment.url" type="video/mp4" />
                                        </video>
                                    </div>
                                </div>

                                <div
                                    class="flex items-center flex-wrap gap-4 w-full h-full p-4"
                                    v-if="messageAttachmentsByType.audio.length"
                                >
                                    <div
                                        v-for="(attachment, index) in messageAttachmentsByType.audio"
                                        :key="index"
                                        class="relative cursor-pointer transition-all duration-300 rounded-lg min-w-[10rem]"
                                    >
                                        <div
                                            class="w-5 h-5 rounded-full flex items-center justify-center bg-slate-50 border border-gray-100 absolute top-0 right-0 translate-x-1/2 -translate-y-1/2"
                                            @click="() => handleRemoveAttachment(index)"
                                        >
                                            <fa class="text-xs cursor-pointer" :icon="['fal', 'close']"></fa>
                                        </div>
                                        <audio
                                            width="320"
                                            height="240"
                                            controls
                                            class="bg-gray-100 rounded-xl rounded-tl-none text-sm mb-2 h-10"
                                        >
                                            <source :src="attachment.url" type="audio/mpeg" />
                                        </audio>
                                    </div>
                                </div>
                            </div>

                            <template v-else>
                                <template v-if="toPreview">
                                    <span
                                        v-if="loadingStates.botJson"
                                        class="inline-flex w-full h-full bg-gray-200 opacity-20 rounded-lg skeleton-animation"
                                    ></span>

                                    <template v-else>
                                        <Preview
                                            :data="selectedBotData"
                                            @toggle-preview="() => (toPreview = !toPreview)"
                                        />
                                    </template>
                                </template>
                                <template v-else-if="selectedDropdownOption === 'email'">
                                    <div class="email_form flex flex-col h-full">
                                        <div>
                                            <!-- Email Fields -->
                                            <FormKit
                                                v-model="emailFrom"
                                                type="text"
                                                label="From:"
                                                disabled
                                                :classes="{
                                                    outer: '!mb-4 formkit-disabled:!opacity-100',
                                                    wrapper: 'flex gap-1 items-center',
                                                    label: '!mb-0 !text-sm !leading-[17px] !font-semibold !text-black-600',
                                                    inner: '!h-[17px]',
                                                    input: '!p-0 !text-gray-500 !font-semibold !leading-[17px]',
                                                }"
                                            />

                                            <div class="flex justify-between items-center mb-4">
                                                <FormKit
                                                    v-model="emailTo"
                                                    type="text"
                                                    disabled
                                                    label="To:"
                                                    :classes="{
                                                        outer: '!mb-0 formkit-disabled:!opacity-100',
                                                        wrapper: 'flex gap-1 items-center',
                                                        label: '!mb-0 !text-sm !leading-[17px] !font-semibold',
                                                        inner: '!h-[17px]',
                                                        input: '!p-0 !text-gray-500 !font-semibold !leading-[17px]',
                                                    }"
                                                />
                                                <div
                                                    class="text-sm leading-[17px] font-semibold text-black-600 ml-4 flex gap-1"
                                                >
                                                    <span
                                                        class="cursor-pointer"
                                                        @click="toggleCCBCC('cc')"
                                                        :class="{ underline: !emailCc || emailCc.trim() === '' }"
                                                        >Cc</span
                                                    >
                                                    <span
                                                        class="cursor-pointer"
                                                        @click="toggleCCBCC('bcc')"
                                                        :class="{ underline: !emailBcc || emailBcc.trim() === '' }"
                                                        >Bcc</span
                                                    >
                                                </div>
                                            </div>

                                            <div v-if="divDisplay.cc" class="mb-4 cc-div">
                                                <FormKit
                                                    type="text"
                                                    label="Cc:"
                                                    v-model="emailCc"
                                                    :classes="{
                                                        outer: '!mb-2',
                                                        wrapper: 'flex gap-1 items-center',
                                                        label: '!mb-0 !text-sm !leading-[17px] !font-semibold',
                                                        inner: '!h-[17px]',
                                                        input: '!p-0 !text-gray-500 !font-semibold !leading-[17px]',
                                                    }"
                                                />
                                            </div>
                                            <div v-if="divDisplay.bcc" class="mb-4 bcc-div">
                                                <FormKit
                                                    type="text"
                                                    label="Bcc:"
                                                    v-model="emailBcc"
                                                    :classes="{
                                                        outer: '!mb-2',
                                                        wrapper: 'flex gap-1 items-center',
                                                        label: '!mb-0 !text-sm !leading-[17px] !font-semibold',
                                                        inner: '!h-[17px]',
                                                        input: '!p-0 !text-gray-500 !font-semibold !leading-[17px]',
                                                    }"
                                                />
                                            </div>

                                            <div class="mb-4 border-b border-gray-200">
                                                <FormKit
                                                    type="text"
                                                    label="Subject:"
                                                    v-model="emailSubject"
                                                    :classes="{
                                                        outer: '!mb-2',
                                                        wrapper: 'flex gap-1 items-center',
                                                        label: '!mb-0 !text-sm !leading-[17px] !font-semibold',
                                                        inner: '!h-[17px]',
                                                        input: '!p-0 !text-gray-500 !font-semibold !leading-[17px]',
                                                    }"
                                                />
                                            </div>
                                        </div>
                                        <div class="bg-white px-6 py-4 rounded flex-1 overflow-y-auto">
                                            <!-- Message Body -->
                                            <jodit_editor
                                                v-model="emailInput"
                                                :config="joditConfigEmail"
                                                :buttons="[
                                                    'bold',
                                                    'italic',
                                                    'strikethrough',
                                                    '|',
                                                    'fontsize',
                                                    'brush',
                                                    '|',
                                                    'eraser',
                                                    '|',
                                                    'ul',
                                                    'ol',
                                                    '|',
                                                    '|',
                                                    'undo',
                                                    'redo',
                                                    '|',
                                                    'spellcheck',
                                                    '|',
                                                    'link',
                                                    'image',
                                                    'table',
                                                ]"
                                            ></jodit_editor>
                                            <!-- Signature Block -->
                                            <!-- <div class="border-t border-[#0071CE] py-4 flex  justify-between">
												<div class="flex items-start gap-4">
													<img
														src="https://randomuser.me/api/portraits/women/44.jpg"
														alt="Profile"
														class="w-[5.5rem] h-[5.5rem] rounded-full object-cover"
													/>
													<div class="email_signature_text">
														<p class="text-sm leading-[18px] font-extrabold text-[#0071CE]">Samuel Crona</p>
														<p class="text-xs leading-[18px] text-[#878787] mb-1.5">Investor Communications Designer</p>
														<p class="mb-0.5 flex items-center gap-2 leading-[14px]">
															<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
																<path d="M1.66668 1.66602H8.33334C8.79168 1.66602 9.16668 2.04102 9.16668 2.49935V7.49935C9.16668 7.95768 8.79168 8.33268 8.33334 8.33268H1.66668C1.20834 8.33268 0.833344 7.95768 0.833344 7.49935V2.49935C0.833344 2.04102 1.20834 1.66602 1.66668 1.66602Z" stroke="#525252" stroke-linecap="round" stroke-linejoin="round"/>
																<path d="M9.16668 2.5L5.00001 5.41667L0.833344 2.5" stroke="#525252" stroke-linecap="round" stroke-linejoin="round"/>
															</svg>
															<a href="mailto:samuel@wallmart.com">samuel@wallmart.com</a>
														</p>
														<p class="mb-0.5 flex items-center gap-2 leading-[14px]">
															<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
																<g clip-path="url(#clip0_10001_99666)">
																	<path d="M4.16666 5.41698C4.3456 5.6562 4.57389 5.85414 4.83605 5.99737C5.09822 6.1406 5.38812 6.22578 5.68609 6.24712C5.98407 6.26846 6.28315 6.22546 6.56305 6.12105C6.84295 6.01664 7.09712 5.85326 7.30832 5.64198L8.55832 4.39198C8.93782 3.99906 9.14781 3.4728 9.14306 2.92656C9.13831 2.38032 8.91921 1.85779 8.53295 1.47152C8.14668 1.08526 7.62415 0.866154 7.07791 0.861407C6.53167 0.85666 6.00541 1.06665 5.61249 1.44614L4.89582 2.15864" stroke="#525252" stroke-linecap="round" stroke-linejoin="round"/>
																	<path d="M5.83332 4.58351C5.65439 4.34429 5.42609 4.14635 5.16393 4.00312C4.90176 3.85988 4.61186 3.77471 4.31389 3.75337C4.01591 3.73203 3.71683 3.77502 3.43693 3.87943C3.15703 3.98384 2.90286 4.14723 2.69166 4.35851L1.44166 5.60851C1.06216 6.00143 0.852174 6.52769 0.856921 7.07393C0.861668 7.62017 1.08077 8.1427 1.46704 8.52897C1.8533 8.91523 2.37583 9.13433 2.92207 9.13908C3.46832 9.14383 3.99457 8.93384 4.38749 8.55434L5.09999 7.84184" stroke="#525252" stroke-linecap="round" stroke-linejoin="round"/>
																</g>
																<defs>
																	<clipPath id="clip0_10001_99666">
																	<rect width="10" height="10" fill="white"/>
																	</clipPath>
																</defs>
															</svg>
															<a href="https://www.wallmart.com" target="_blank">www.wallmart.com</a>
														</p>
														<p class="flex items-center gap-2">
															<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
																<g clip-path="url(#clip0_10001_99671)">
																	<path d="M9.16666 7.05069V8.30069C9.16713 8.41673 9.14336 8.53159 9.09687 8.63792C9.05038 8.74424 8.9822 8.83969 8.89669 8.91813C8.81118 8.99658 8.71023 9.05631 8.6003 9.09349C8.49038 9.13066 8.3739 9.14447 8.25833 9.13402C6.97617 8.99471 5.74458 8.55658 4.66249 7.85486C3.65575 7.21513 2.80222 6.3616 2.16249 5.35486C1.45832 4.26786 1.02009 3.03027 0.883326 1.74236C0.872914 1.62714 0.886607 1.51101 0.923534 1.40137C0.960462 1.29173 1.01981 1.19098 1.09781 1.10553C1.17581 1.02009 1.27074 0.95182 1.37657 0.905076C1.4824 0.858331 1.5968 0.834134 1.71249 0.834025H2.96249C3.1647 0.832035 3.36074 0.903641 3.51406 1.0355C3.66738 1.16735 3.76752 1.35046 3.79583 1.55069C3.84859 1.95072 3.94643 2.34349 4.08749 2.72152C4.14355 2.87066 4.15569 3.03274 4.12245 3.18856C4.08922 3.34438 4.01202 3.4874 3.89999 3.60069L3.37083 4.12986C3.96397 5.173 4.82768 6.03671 5.87083 6.62986L6.39999 6.10069C6.51328 5.98866 6.65631 5.91146 6.81213 5.87823C6.96794 5.845 7.13002 5.85713 7.27916 5.91319C7.65719 6.05425 8.04996 6.1521 8.44999 6.20486C8.65239 6.23341 8.83724 6.33536 8.96938 6.49131C9.10152 6.64727 9.17173 6.84635 9.16666 7.05069Z" stroke="#525252" stroke-linecap="round" stroke-linejoin="round"/>
																</g>
																<defs>
																	<clipPath id="clip0_10001_99671">
																	<rect width="10" height="10" fill="white"/>
																	</clipPath>
																</defs>
															</svg>
															<a href="tell:+12345688897">+1 234 568 8897</a>
														</p>
													</div>
												</div>
												<img
													src="https://picsum.photos/id/237/200/300"
													alt="Walmart Logo"
													class="w-[89px] h-9 object-cover"
												/>
											</div> -->
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <jodit_editor
                                        ref="joditRef"
                                        :key="joditConfig"
                                        v-model="messageInput"
                                        :config="joditConfig"
                                        :isDisabled="loadingStates.sendMessage"
                                        :selectionEmitEnabled="selectionEmitEnabled"
                                        @update:modelValue="handleKeyPress"
                                        @hasSelected="hasSelected"
                                    ></jodit_editor>
                                </template>
                            </template>
                        </div>
                    </div>
                    <div class="options !mt-0 pt-6" :class="[toPreview ? '!w-auto ml-6 !mt-auto !mb-auto' : '']">
                        <div
                            v-show="selectedDropdownOption !== 'note' && !toPreview"
                            class="option-icons gap-2 items-center text-gray-300"
                        >
                            <!-- <CannedResponseDropdown
                                :response-array="responseArray"
                                @click="handleCannedFetch"
                                @handle-canned-reponse="OpenCannedReponse"
                            > -->
                            <div @click="() => (modelStates.canned_responses = true)">
                                <fa :icon="['fal', 'file-pen']" class="cursor-pointer !text-xl !leading-5" />
                            </div>
                            <!-- </CannedResponseDropdown> -->
                            <SendBotsDropdown
                                :bots-array="botsArray"
                                :send-bot-message="handleBotSelect"
                                @SearchTag="handleSearchBots"
                                @click="handleBotFetch"
                            >
                                <fa :icon="['fal', 'message-bot']" class="cursor-pointer !text-xl !leading-5" />
                            </SendBotsDropdown>
                            <DiaryDropdown :diary-array="diaryArray">
                                <fa :icon="['fal', 'calendar']" class="cursor-pointer !text-xl !leading-5" />
                            </DiaryDropdown>

                            <div>
                                <label for="chat_attachment">
                                    <fa class="cursor-pointer !text-xl !leading-5" :icon="['fal', 'paperclip']"></fa>
                                </label>

                                <input
                                    id="chat_attachment"
                                    type="file"
                                    v-show="false"
                                    multiple
                                    @change="handleAttachments"
                                />
                            </div>

                            <EmojiDropdown :attach-emoji>
                                <fa :icon="['fal', 'face-smile']" class="cursor-pointer !text-xl !leading-5" />
                            </EmojiDropdown>

                            <div class="option-icons">
                                <TagDropDown
                                    :single-data-trees="dropdownSingle"
                                    :is-search-able="true"
                                    :is-multiple="false"
                                    placement="top-start"
                                >
                                    <fa :icon="['fal', 'tag']" class="cursor-pointer !text-xl !leading-5" />
                                </TagDropDown>
                            </div>
                        </div>
                        <div class="ml-auto">
                            <SendButton
                                @click="handleSendMessage"
                                :label="selectedDropdownOption === 'note' ? 'Save' : 'Send'"
                                :isLoading="loadingStates.sendMessage"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>
    <!-- <div
            v-if="openNoteRef"
            class=" p-4 rounded-lg h-full transition-none"
            style="min-height: 120px"
            id="send_box"
            :class="[openType ? 'full-container' : 'shrunk_anim']"
        >
            <div class="box-container h-full" :class="[openType ? '!max-h-full' : '']">
                <div class="w-full flex-grow flex flex-col rounded overflow-y-auto h-full">
                    <div class="mode">
                        <div class="select_mode">
                            <div class="replyMode">
                                <VDropdown
                                    placement="bottom-start"
                                    auto-boundary-max-size
                                    :prevent-overflow="true"
                                    :overflow-padding="10"
                                >
                                    <span class="cursor-pointer">Note </span>
                                    <fa :icon="['fas', 'chevron-down']" class="cursor-pointer" />
                                    <template #popper="{ hide }">
                                        <ul class="p-4">
                                            <li
                                                class="text-dark-100 italic text-sm flex p-2 rounded-lg items-center cursor-pointer hover:bg-gray-100"
                                                @click="(openReplyMethod(), hide())"
                                            >
                                                <fa
                                                    :icon="['fal', 'reply']"
                                                    class="text-gray-navtext mr-1 text-lg"
                                                />Add reply
                                            </li>
                                        </ul>
                                    </template>
                                </VDropdown>
                            </div>
                        </div>
                        <fa
                            :icon="[
                                'fal',
                                openType
                                    ? 'arrow-down-left-and-arrow-up-right-to-center'
                                    : 'arrow-up-right-and-arrow-down-left-from-center',
                            ]"
                            class="!text-sm !text-gray-300 cursor-pointer"
                            @click="toggleFullType"
                        />
                    </div>
                    <div
                        class="message_area overflow-y-auto h-full hide_scroll pt-1.5"
                        ref="noteTextArea"
                        :class="
                            loadingStates.sendMessage
                                ? '*:!pointer-events-none cursor-not-allowed select-none opacity-60'
                                : ''
                        "
                    >
                        <jodit_editor
                            :key="joditConfig"
                            v-model="noteContent"
                            :config="joditConfig"
                            :buttons="[]"
                            @handleEnterKey="handleEnterOnNote"
                            @update:modelValue="handleScrollToBottom"
                        ></jodit_editor>
                    </div>
                    <div class="mt-auto ml-auto">
                        <AppButton
                            btnText="Save"
                            variant="blue"
                            @click="saveNote"
                            :isLoading="loadingStates.sendMessage"
                        />
                    </div>
                </div>
            </div>
        </div> -->

    <SendCannedResponse
        v-else
        :data="cannedDetail"
        @send-canned-response="SendCannedMessage"
        @close-canned-response="$emit('closeCannedResponse')"
    >
        <CannedResponseDropdown
            :response-array="responseArray"
            @click="handleCannedFetch"
            @handle-canned-reponse="OpenCannedReponse"
        >
            <fa :icon="['fal', 'file-pen']" class="cursor-pointer !text-[20px] !font-[300] !leading-normal" />
        </CannedResponseDropdown>
        <SendBotsDropdown :bots-array="botsArray" :send-bot-message="handleBotSelect" @click="handleBotFetch">
            <fa :icon="['fal', 'message-bot']" class="cursor-pointer !text-[20px] !font-[300] !leading-normal" />
        </SendBotsDropdown>
    </SendCannedResponse>

    <SelectCannedResponse
        v-if="modelStates.canned_responses"
        @handleCloseModal="() => (modelStates.canned_responses = false)"
        @handleSelectCannedResponse="handleSelectCannedResponse"
    />
</template>
<script setup>
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import AxiosAuth from "@/config/AxiosAuthConfig";
import { getAllBots, getCannedResponseList } from "@/api/SettingServices";
import SendCannedResponse from "@/components/settings/inbox/inbox-component/SendCannedResponse.vue";
// import AppButton from "@/components/appComponents/AppButton.vue";
import CannedResponseDropdown from "@/components/settings/inbox/inbox-component/dropdowns/CannedResponseDropdown.vue";
import DiaryDropdown from "@/components/settings/inbox/inbox-component/dropdowns/DiaryDropdown.vue";
import EmojiDropdown from "@/components/settings/inbox/inbox-component/dropdowns/EmojiDropdown.vue";
import SendBotsDropdown from "@/components/settings/inbox/inbox-component/dropdowns/SendBotsDropdown.vue";

import { chatroomStore, sendEmailNotification } from "@/stores/messagesStore";
import { agentDetails } from "@/stores/contactsStore";
import { socketConn } from "@/stores/socketConn";
import { useTenantStore } from "@/stores/tenant";

// import LabelInfo from "./LabelInfo.vue";
import SendButton from "./SendButton.vue";
import TagDropDown from "./dropdowns/TagDropDown.vue";
import Preview from "./Preview.vue";
import AxiosChat from "@/config/AxiosChatConfig";
import { formateMessageObject } from "@/utils/utility";
import { convertHTMLIntoMarkdown } from "@/utils/markdown";
import { getUserImage } from "@/composables/globals";
import { useMessenger } from "@/composables/useMessenger";
import jodit_editor from "../../../globals/Jodit/jodit_editor.vue";
import { Jodit } from "jodit-pro/es2021/jodit";
import { useChatStore } from "@/stores/chatStore";
import { convertJsonToFormData } from "@/utils/utility";
import JoditOptions from "./JoditOptions.vue";
import SelectCannedResponse from "./modals/SelectCannedResponse.vue";
import { FormKit } from "@formkit/vue";

// import SendCannedResponse from './SendCannedResponse.vue';

const fileIcon = {
    pdf: ["fal", "file-pdf"],
    excel: ["fal", "file-excel"],
    word: ["fal", "file-word"],
    default: ["fal", "file"],
};
const Jodit_key = import.meta.env.VITE_APP_JODIT_KEY;

const signatureTemplate = `<br><div class="border-t border-[#0071CE] py-4 flex justify-between">
                                                <div class="flex items-start gap-4">
                                                    <img
                                                        src="https://randomuser.me/api/portraits/women/44.jpg"
                                                        alt="Profile"
                                                        class="w-[5.5rem] h-[5.5rem] rounded-full object-cover"
                                                    />
                                                    <div class="email_signature_text">
                                                        <p class="text-sm leading-[18px] font-extrabold text-[#0071CE]">
                                                            Samuel Crona
                                                        </p>
                                                        <p class="text-xs leading-[18px] text-[#878787] mb-1.5">
                                                            Investor Communications Designer
                                                        </p>
                                                        <p class="mb-0.5 flex items-center gap-2 leading-[14px]">
                                                            <svg
                                                                width="10"
                                                                height="10"
                                                                viewBox="0 0 10 10"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M1.66668 1.66602H8.33334C8.79168 1.66602 9.16668 2.04102 9.16668 2.49935V7.49935C9.16668 7.95768 8.79168 8.33268 8.33334 8.33268H1.66668C1.20834 8.33268 0.833344 7.95768 0.833344 7.49935V2.49935C0.833344 2.04102 1.20834 1.66602 1.66668 1.66602Z"
                                                                    stroke="#525252"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                />
                                                                <path
                                                                    d="M9.16668 2.5L5.00001 5.41667L0.833344 2.5"
                                                                    stroke="#525252"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                                />
                                                            </svg>
                                                            <a href="mailto:samuel@wallmart.com">samuel@wallmart.com</a>
                                                        </p>
                                                        <p class="mb-0.5 flex items-center gap-2 leading-[14px]">
                                                            <svg
                                                                width="10"
                                                                height="10"
                                                                viewBox="0 0 10 10"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <g clip-path="url(#clip0_10001_99666)">
                                                                    <path
                                                                        d="M4.16666 5.41698C4.3456 5.6562 4.57389 5.85414 4.83605 5.99737C5.09822 6.1406 5.38812 6.22578 5.68609 6.24712C5.98407 6.26846 6.28315 6.22546 6.56305 6.12105C6.84295 6.01664 7.09712 5.85326 7.30832 5.64198L8.55832 4.39198C8.93782 3.99906 9.14781 3.4728 9.14306 2.92656C9.13831 2.38032 8.91921 1.85779 8.53295 1.47152C8.14668 1.08526 7.62415 0.866154 7.07791 0.861407C6.53167 0.85666 6.00541 1.06665 5.61249 1.44614L4.89582 2.15864"
                                                                        stroke="#525252"
                                                                        stroke-linecap="round"
                                                                        stroke-linejoin="round"
                                                                    />
                                                                    <path
                                                                        d="M5.83332 4.58351C5.65439 4.34429 5.42609 4.14635 5.16393 4.00312C4.90176 3.85988 4.61186 3.77471 4.31389 3.75337C4.01591 3.73203 3.71683 3.77502 3.43693 3.87943C3.15703 3.98384 2.90286 4.14723 2.69166 4.35851L1.44166 5.60851C1.06216 6.00143 0.852174 6.52769 0.856921 7.07393C0.861668 7.62017 1.08077 8.1427 1.46704 8.52897C1.8533 8.91523 2.37583 9.13433 2.92207 9.13908C3.46832 9.14383 3.99457 8.93384 4.38749 8.55434L5.09999 7.84184"
                                                                        stroke="#525252"
                                                                        stroke-linecap="round"
                                                                        stroke-linejoin="round"
                                                                    />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_10001_99666">
                                                                        <rect width="10" height="10" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                            <a href="https://www.wallmart.com" target="_blank"
                                                                >www.wallmart.com</a
                                                            >
                                                        </p>
                                                        <p class="flex items-center gap-2">
                                                            <svg
                                                                width="10"
                                                                height="10"
                                                                viewBox="0 0 10 10"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <g clip-path="url(#clip0_10001_99671)">
                                                                    <path
                                                                        d="M9.16666 7.05069V8.30069C9.16713 8.41673 9.14336 8.53159 9.09687 8.63792C9.05038 8.74424 8.9822 8.83969 8.89669 8.91813C8.81118 8.99658 8.71023 9.05631 8.6003 9.09349C8.49038 9.13066 8.3739 9.14447 8.25833 9.13402C6.97617 8.99471 5.74458 8.55658 4.66249 7.85486C3.65575 7.21513 2.80222 6.3616 2.16249 5.35486C1.45832 4.26786 1.02009 3.03027 0.883326 1.74236C0.872914 1.62714 0.886607 1.51101 0.923534 1.40137C0.960462 1.29173 1.01981 1.19098 1.09781 1.10553C1.17581 1.02009 1.27074 0.95182 1.37657 0.905076C1.4824 0.858331 1.5968 0.834134 1.71249 0.834025H2.96249C3.1647 0.832035 3.36074 0.903641 3.51406 1.0355C3.66738 1.16735 3.76752 1.35046 3.79583 1.55069C3.84859 1.95072 3.94643 2.34349 4.08749 2.72152C4.14355 2.87066 4.15569 3.03274 4.12245 3.18856C4.08922 3.34438 4.01202 3.4874 3.89999 3.60069L3.37083 4.12986C3.96397 5.173 4.82768 6.03671 5.87083 6.62986L6.39999 6.10069C6.51328 5.98866 6.65631 5.91146 6.81213 5.87823C6.96794 5.845 7.13002 5.85713 7.27916 5.91319C7.65719 6.05425 8.04996 6.1521 8.44999 6.20486C8.65239 6.23341 8.83724 6.33536 8.96938 6.49131C9.10152 6.64727 9.17173 6.84635 9.16666 7.05069Z"
                                                                        stroke="#525252"
                                                                        stroke-linecap="round"
                                                                        stroke-linejoin="round"
                                                                    />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_10001_99671">
                                                                        <rect width="10" height="10" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                            <a href="tell:+12345688897">+1 234 568 8897</a>
                                                        </p>
                                                    </div>
                                                </div>
                                                <img
                                                    src="https://picsum.photos/id/237/200/300"
                                                    alt="Walmart Logo"
                                                    class="w-[89px] h-9 object-cover"
                                                />
                                            </div>`;

const configFor = {
    reply: {
        placeholder: "Enter message here (sent to buyer only)...",
        autocomplete: {},
    },
    note: {
        placeholder: "Enter message here ...",
        autocomplete: function (agents) {
            return {
                insertValueRenderer: (item) => {
                    const strong = document.createElement("strong");
                    const underline = document.createElement("u");
                    underline.innerText = item.value;
                    strong.append(underline);
                    return strong;
                },
                itemRenderer: (item) => `
                                <div class="inbox_agent_search_list hover:bg-gray-100 p-1.5 rounded-lg">
                                    <div class="inbox_agent_search_img">
                                        <img src="${getUserImage()}" alt="${item.title}" />
                                    </div>

                                    <span class="inbox_agent_search_text">
                                    ${item.title}
                                    </span>
                                </div>
            `,
                sources: [agents],
            };
        },
    },
};

const joditConfigEmail = {
    license: Jodit_key,
    zIndex: 0,
    readonly: false,
    // preset: 'inline',
    activeButtonsInReadOnly: ["source", "fullsize", "print", "about", "dots"],
    toolbarButtonSize: "middle",
    theme: "default",
    defaultMode: Jodit.MODE_WYSIWYG,
    sizeLG: 900,
    sizeMD: 700,
    sizeSM: 400,
    colorPickerDefaultTab: "background",
    imageDefaultWidth: 300,
    tabIndex: -1,
    toolbar: true,
    enter: "P",
    direction: "",
    language: "auto",
    debugLanguage: false,
    saveModeInCookie: false,
    spellcheck: true,
    editorCssClass: false,
    triggerChangeEvent: true,
    allowResizeY: false,
    allowResizeX: false,
    pageBreak: {
        separator: '<div style="page-break-before: always"></div>',
    },
    autocomplete: {
        insertValueRenderer: (item) => {
            console.log("autcomplete renderd");
            const a = document.createElement("a");

            a.href = item.link;
            a.innerText = item.name;

            return a;
        },

        sources: [
            {
                feed: (query) => {
                    if (query && query.length && query[0] == "{") {
                        let temp = query.slice(1);
                        console.log(query);
                        console.log(filteredData, "filterd data");
                        return filteredData.filter((value) => {
                            return value.title.toLowerCase().includes(temp);
                        });
                    }
                },
                itemRenderer: (item) => "{" + item.tag_name + "}",
                insertValueRenderer: (obj) =>
                    '<span contenteditable="false"  class="non-editable" style=background-color:#DDE3E4;color:#000;font-style:italic;display:inline-block; tag-mod=' +
                    obj.mod +
                    " tag-type=" +
                    obj.type +
                    " tag-contact=" +
                    obj.num +
                    " tag-id=" +
                    obj.id +
                    "  tag-group=" +
                    obj.is_group +
                    " tag-multigroup=" +
                    obj.multi_group +
                    ">" +
                    "{" +
                    modTypes[obj.mod][obj.type] +
                    "-" +
                    obj.tag_name +
                    "}" +
                    "</span>",
            },
        ],
    },
    controls: {
        font: {
            list: {
                "Roboto Medium,Arial,sans-serif": "Roboto",
                "Inter Medium, Arial, sans-serif": "Inter",
            },
        },

        myDropdown: {
            iconURL: "https://voza-dev.voza-dev.io/static-content/brackets-curly-regular.svg",
            isShowPopper: true,
            exec: (obj) => {
                currentEditor = obj;
                // console.log(obj, 'jodit123');
                // Get button position
                // onMounted(() => {
                //     nextTick(() => {
                const buttonElement = document.querySelector(
                    ".jodit-toolbar-button_myDropdown .jodit-toolbar-button__button",
                    ".jodit-toolbar-button_myDropdown .jodit-toolbar-button__button",
                );
                // debugger;
                if (buttonElement) {
                    const rect = buttonElement.getBoundingClientRect();
                    dropdownTop.value = rect.bottom + 11;
                    dropdownLeft.value = rect.left - 64;
                }
                //     });
                // });
                // Toggle dropdown visibility
                showDropdown.value = !showDropdown.value;
                checkSwitch();
            },
        },
    },
};

const joditConfig = ref({
    license: Jodit_key,
    enter: "p",
    inline: false,
    toolbar: false,
    addNewLine: false, // [info]: responsible for the new line break at the bottom
    askBeforePasteHTML: false,
    processPasteHTML: true,
    disabled: false,
    useSearch: false,
    toolbarInline: true,
    toolbarInlineForSelection: true,
    spellcheck: true,
    toolbarInlineDisableFor: ["bold"],
    toolbarInlineDisabledButtons: ["bold"],
    style: { font: "16px", color: "#0f1010" },

    popup: {
        a: Jodit.atom([]),
        img: Jodit.atom([]),
        cells: Jodit.atom([]),
        toolbar: Jodit.atom([]),
        jodit: Jodit.atom([]),
        iframe: Jodit.atom([]),
        "jodit-media": Jodit.atom([]),
        selection: Jodit.atom(["bold", "italic", "strikethrough", "ul", "ol", "paragraph", "spellcheck"]),
    },

    controls: {
        ...Jodit.defaultOptions.controls,
        ul: {
            ...Jodit.defaultOptions.controls.ul,
            list: undefined,
        },
        ol: {
            ...Jodit.defaultOptions.controls.ol,
            list: undefined,
        },
    },

    cleanHTML: {
        removeEmptyElements: true,
        replaceNBSP: true,
        fillEmptyParagraph: false,
        denyTags: "script",
    },
    defaultActionOnPaste: Jodit.constants.INSERT_ONLY_TEXT,
    placeholder: configFor.reply.placeholder,
});

// eslint-disable-next-line no-unused-vars
const props = defineProps({
    cannedStatus: {
        type: Boolean,
        default: false,
    },
    cannedDetail: {
        type: Object,
        default: () => ({}),
    },
    // [info]: not using anywhere. commeting it for now
    // ifLabels: {
    //     type: Boolean,
    //     default: true,
    // },
    // [info]: this is only for the jodit editor above
    selectionEmitEnabled: {
        type: Boolean,
        default: false,
    },
});

// const APIURL = import.meta.env.VITE_APP_API_CHAT_SERVER_URL;
// const BOT_URL = import.meta.env.VITE_GET_BOT_JSON;
// let note = null;
let agentList = [];
let botList = [];
const toPreview = ref(false);
const selectedBotData = ref({});
const selectedBotDataJson = ref({});
const isShowJoditOptions = ref(false);
const modelStates = ref({
    canned_responses: false,
});

// [info]: not sure what this emit 'showFullScreen' do
const emits = defineEmits([
    "ShowCannedReponse",
    "closeCannedResponse",
    "receiveSendedMessage",
    "handleModeChange",
    //  "showFullScreen"
]);

const documentType = ["pdf", "excel", "spreadsheet", "msword", "document", "powerpoint", "presentation"];
const dropdownSingle = ref([
    {
        id: 41,
        icon: "brackets-curly",
        title: "Currency_symbol",
        subnav: [],
        mod: 2,
        isValue: true,
        tag_name: "Currency_symbol",
        tag_value: "£600",
        type: 0,
        emit: "none",
    },
    {
        id: 45,
        icon: "brackets-curly",
        title: "Currency_symbol",
        subnav: [],
        mod: 2,
        isValue: true,
        tag_name: "Currency_symbol1",
        tag_value: "£200",
        type: 0,
        emit: "none",
    },
    {
        id: 42,
        icon: "brackets-curly",
        title: "Currency_words",
        subnav: [],
        mod: 2,
        isValue: true,
        tag_name: "Currency_words",
        tag_value: "GBP",
        type: 0,
        emit: "none",
    },
    {
        id: 43,
        icon: "brackets-curly",
        title: "Price",
        subnav: [],
        mod: 2,
        isValue: true,
        tag_name: "Price",
        tag_value: "285",
        type: 0,
        emit: "none",
    },
    {
        id: 44,
        icon: "brackets-curly",
        title: "Price_words",
        subnav: [],
        mod: 2,
        isValue: true,
        tag_name: "Price_words",
        tag_value: "Two Hundred Eighty-Five",
        type: 0,
        emit: "none",
    },
    {
        id: 63,
        icon: "brackets-curly",
        title: "Lat",
        subnav: [],
        mod: 2,
        isValue: true,
        tag_name: "Lat",
        tag_value: "51.490868",
        type: 0,
        emit: "none",
    },
    {
        id: 77,
        icon: "brackets-curly",
        title: "Property_main_image",
        subnav: [],
        mod: 2,
        isValue: true,
        tag_name: "Property_main_image",
        tag_value: "",
        type: 0,
        emit: "none",
    },
]);
// const OptionsDropdown_list = ref([
//     {
//         id: 41,
//         icon: "brackets-curly",
//         title: "Smart tags",
//         subnav: [],
//         mod: 2,
//         isValue: true,
//         tag_name: "Currency_symbol",
//         tag_value: "£600",
//         type: 0,
//         emit: "none",
//         multi: true,
//     },
//     {
//         id: 45,
//         icon: "face-smile",
//         title: "Emoji",
//         subnav: [],
//         mod: 2,
//         isValue: true,
//         tag_name: "Currency_symbol1",
//         tag_value: "£200",
//         type: 0,
//         emit: "none",
//         multi: true,
//     },
//     {
//         id: 42,
//         icon: "image",
//         title: "Image",
//         subnav: [],
//         mod: 2,
//         isValue: true,
//         tag_name: "Currency_words",
//         tag_value: "GBP",
//         type: 0,
//         emit: "none",
//         multi: false,
//     },
//     {
//         id: 43,
//         icon: "paperclip",
//         title: "Attach file",
//         subnav: [],
//         mod: 2,
//         isValue: true,
//         tag_name: "Price",
//         tag_value: "285",
//         type: 0,
//         emit: "none",
//         multi: false,
//     },
//     {
//         id: 43,
//         icon: "clapperboard-play",
//         title: "Embed video",
//         subnav: [],
//         mod: 2,
//         isValue: true,
//         tag_name: "Price",
//         tag_value: "285",
//         type: 0,
//         emit: "none",
//         multi: true,
//     },
//     {
//         id: 43,
//         icon: "calendar",
//         title: "Send calendar invite",
//         subnav: [],
//         mod: 2,
//         isValue: true,
//         tag_name: "Price",
//         tag_value: "285",
//         type: 0,
//         emit: "none",
//         multi: true,
//     },
//     {
//         id: 43,
//         icon: "message-bot",
//         title: "Trigger bot",
//         subnav: [],
//         mod: 2,
//         isValue: true,
//         tag_name: "Price",
//         tag_value: "285",
//         type: 0,
//         emit: "none",
//         multi: true,
//     },
//     {
//         id: 43,
//         icon: "message-plus",
//         title: "Canned response",
//         subnav: [],
//         mod: 2,
//         isValue: true,
//         tag_name: "Price",
//         tag_value: "285",
//         type: 0,
//         emit: "none",
//         multi: true,
//     },
// ]);
const responseArray = ref([
    {},

    // {
    //     title: 'Welcome message',
    //     subnav: [],
    // },
    // {
    //     title: 'Report a problem',
    //     subnav: [],
    // },
    // {
    //     seperator: true,
    //     title: '',
    //     subnav: [],
    // },
    // {
    //     title: 'Save as canned response',
    //     icon: 'square-down',
    //     subnav: [
    //         {
    //             heading: true,
    //             title: 'OVERWRITE CANNED RESPONSE',
    //             subnav: [],
    //         },
    //         {
    //             title: 'Welcome message',
    //             subnav: [],
    //         },
    //         {
    //             title: 'Report a problem',
    //             subnav: [],
    //         },
    //         {
    //             seperator: true,
    //             title: '',
    //             subnav: [],
    //         },
    //         {
    //             title: 'Save as new canned response',
    //             subnav: [],
    //         },
    //     ],
    // },
    // {
    //     title: 'Delete canned response',
    //     icon: 'trash',
    //     subnav: [
    //         {
    //             heading: true,
    //             title: 'DELETE CANNED RESPONSE',
    //             subnav: [],
    //         },
    //         {
    //             title: 'Welcome message',
    //             subnav: [],
    //         },
    //         {
    //             title: 'Report a problem',
    //             subnav: [],
    //         },
    //     ],
    // },
]);
const botsArray = ref([
    {
        id: 1,
        heading: true,
        title: "SEND BOTS",
        subnav: [],
    },
]);
const diaryArray = ref([
    {
        heading: true,
        title: "SEND CALENDAR INVITE",
        subnav: [],
    },
    {
        title: "Create a diary event",
        icon: "calendar",
        subnav: [
            {
                heading: true,
                title: "CREATE DIARY EVENT",
                subnav: [],
            },
            {
                title: "Viewing",
                icon: "eye",
                subnav: [],
            },
            {
                title: "Valuation",
                icon: "gavel",
                subnav: [],
            },
            {
                title: "Meeting",
                icon: "users",
                subnav: [],
            },
            {
                title: "Inspection",
                icon: "shield",
                subnav: [],
            },
        ],
    },
    {
        title: "Send booking slots (Your availability only)",
        icon: "calendar-circle-user",
        subnav: [
            {
                heading: true,
                title: "SEND BOOKING SLOTS (YOUR AVAILABILTY ONLY)",
                subnav: [],
            },
            {
                title: "Viewing",
                icon: "eye",
                subnav: [],
            },
            {
                title: "Valuation",
                icon: "gavel",
                subnav: [],
            },
            {
                title: "Meeting",
                icon: "users",
                subnav: [],
            },
            {
                title: "Inspection",
                icon: "shield",
                subnav: [],
            },
        ],
    },
    {
        title: "Send booking slots (Any team memeber)",
        icon: "calendar-days",
        subnav: [
            {
                heading: true,
                title: "SEND BOOKING SLOTS (ANY TEAM MEMBER)",
                subnav: [],
            },
            {
                title: "Viewing",
                icon: "eye",
                subnav: [],
            },
            {
                title: "Valuation",
                icon: "gavel",
                subnav: [],
            },
            {
                title: "Meeting",
                icon: "users",
                subnav: [],
            },
            {
                title: "Inspection",
                icon: "shield",
                subnav: [],
            },
        ],
    },
]);
const openType = ref(false);
const messageInput = ref("");
const emailInput = ref(signatureTemplate);

// let timerInstance = null;
// let enterButtonClicked = 0;
// const agentsList = ref([]);
// const searchedAgentList = ref([]);
// const noteContent = ref("");
const messageAttachments = ref([]);
const messageAttachmentsByType = computed(() => {
    return {
        images: messageAttachments.value.filter((attachment) => attachment.file.type.includes("image")),
        documents: messageAttachments.value.filter((attachment) =>
            documentType.some((type) => attachment.file.type.includes(type)),
        ),
        videos: messageAttachments.value.filter((attachment) => attachment.file.type.includes("video")),
        audio: messageAttachments.value.filter((attachment) => attachment.file.type.includes("audio")),
    };
});
const dropdownOptions = ref([
    {
        label: "Add note",
        icon: "note",
        value: "note",
    },
    {
        label: "Add reply",
        icon: "reply",
        value: "reply",
    },
    {
        label: "Send email",
        icon: "message",
        value: "email",
    },
]);
const selectedDropdownOption = ref("reply");
const optionsActiveState = ref({
    bold: false,
    italic: false,
    strikethrough: false,
    insertunorderedlist: false,
    insertorderedlist: false,
    blockquote: false,
    toggleSpellcheck: true,
});
// const mentionedAgents = ref([]);

const loadingStates = ref({
    sendMessage: false,
    botJson: false,
});

// [info]: ELEM
const joditRef = ref(null);
// const messageTextArea = ref(null);
// const noteTextArea = ref(null);

const tenantStore = useTenantStore();
const tenantDetails = tenantStore.getTenant;
const chatStore = useChatStore();
const messenger = useMessenger();

// [info]: methods
// const handleScrollToBottom = () => {
//     nextTick(() => {
//         noteTextArea.value?.scrollTo({
//             top: noteTextArea.value.scrollHeight,
//             behavior: "smooth",
//         });
//     });
// };

const handleStyles = (style) => {
    if (!style) return;
    if (style === "toggleSpellcheck")
        optionsActiveState.value = { ...optionsActiveState.value, [style]: !optionsActiveState.value[style] };

    joditRef.value.handleStyles(style);
};

const handleSelectCannedResponse = (cannedResponse) => {
    if (!cannedResponse) return;
    messageInput.value = cannedResponse;
    modelStates.value.canned_responses = false;
};

const hasSelected = async (selectedOptions) => {
    if (selectedOptions) {
        optionsActiveState.value = { ...optionsActiveState.value, ...selectedOptions };
        isShowJoditOptions.value = true;
    } else {
        isShowJoditOptions.value = false;
    }
};

function formatFileSize(bytes) {
    if (bytes === 0) return "0 Bytes";
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    const value = bytes / Math.pow(1024, i);
    return `${value.toFixed(2)} ${sizes[i]}`;
}

const getFileType = (doc) => {
    const ext = doc.split(".").pop().toLowerCase();
    if (ext === "pdf") return "pdf";
    if (["xls", "xlsx", "csv"].includes(ext)) return "excel";
    if (["doc", "docx"].includes(ext)) return "word";
    return "default";
};

const handleSendMessage = () => {
    if (toPreview.value) {
        sendMessage(null, true);
    } else if (selectedDropdownOption.value === "reply") {
        sendMessage();
    } else if (selectedDropdownOption.value === "note") {
        const popup = document.querySelector(".jodit-popup");
        if (!popup) {
            sendMessage(true);
        }
    } else if (selectedDropdownOption.value === "email") {
        sendMessage(null, false, true);
    } else {
        return;
    }
};

const handleOptionClick = async (selectedOption) => {
    openType.value = false;
    messageInput.value = "";
    messageAttachments.value = [];

    if (selectedOption === selectedDropdownOption.value) return;

    if (selectedOption === "note") {
        const agents = await getAgents();
        joditConfig.value = {
            ...joditConfig.value,
            placeholder: configFor.note.placeholder,
            autocomplete: configFor.note.autocomplete(agents),
        };
    } else if (selectedOption === "reply") {
        joditConfig.value = {
            ...joditConfig.value,
            ...configFor.reply,
        };
    }

    selectedDropdownOption.value = selectedOption;
    emits("handleModeChange", selectedOption);
};

const handleAttachments = (event) => {
    const newAttachments = Array.from(event.target.files).map((file) => ({
        file,
        url: URL.createObjectURL(file),
    }));
    messageAttachments.value = [...messageAttachments.value, ...newAttachments];
};

const handleRemoveAttachment = (index) => {
    messageAttachments.value.splice(index, 1);
};

// const addAgentToNote = (agent) => {
//     const mention = {
//         uuid: agent.uuid,
//         email: agent.email,
//         name: `${agent.first_name} ${agent.surname || "Test"}`,
//     };
// [info]: can't figure out what this mentionedAgents.value do
//     mentionedAgents.value.push(mention);
//     const mentionText = `${mention.name} `;
//     noteContent.value = noteContent.value + mentionText;

//     // document.getElementById('notepad').innerHTML =
//     //     document.getElementById('notepad').innerHTML +
//     //     `<p test-data=${agent.uuid}--${agent.email}><strong>${agent.first_name} ${agent.surname || 'Test'}</strong></p>`;

//     agentsList.value = [];
// };

// const handleEnterOnNote = (e) => {};

// const saveNote = (e) => {
//     // openNoteRef.value = false;
//     // note = Jodit.modules.Helpers.stripTags(messageInput.value.replaceAll("<br>", "\n")) || null;
//     // noteContent.value = "";
//     // mentionedAgents.value = [];
//     // note =
//     //     document.getElementById('notepad').value === ''
//     //         ? null
//     //         : document.getElementById('notepad').value;
//     // document.getElementById('notepad').value = '';

// };

const toggleFullType = () => {
    openType.value = !openType.value;
    setTimeout(() => {
        if (openType.value) {
            document.querySelector("body").style.overflow = "hidden";
            document.querySelector("#send_box").classList.add("expand_anim");
        } else {
            document.querySelector("body").style.overflow = "auto";
            document.querySelector("#send_box").classList.remove("expand_anim");
        }
    }, 50);
};
// const closeFullType = () => {
//     openType.value = false;
// };
// const openNoteRef = ref(false);
// const openNoteMethod = () => {
//     openNoteRef.value = true;
//     getAgents();
// };
// const openReplyMethod = () => {
//     openNoteRef.value = false;
// };

// const attachFile = () => {
//     document.getElementById("attach_file").click();
// };

const attachEmoji = (emoji) => {
    if (emoji) {
        joditRef.value.insertHTML(emoji);
    }
};

const populateBots = (bots = []) => {
    const hasBots = bots.length > 0;

    const botsBaseList = [
        {
            heading: true,
            id: 0,
            subnav: [],
            title: hasBots ? "SEND BOTS" : "No bots available",
        },
    ];

    if (!hasBots) return botsBaseList;

    if (!botList.length) {
        botList = bots
            .filter((bot) => !bot.heading)
            .map((bot) => ({
                icon: "message-bot",
                id: bot.id,
                subnav: [],
                title: bot.name || bot.title,
            }));
        return [...botsBaseList, ...botList];
    }

    return [...botsBaseList, ...bots];
};

const handleBotFetch = async () => {
    let bots = [];
    if (botList.length) {
        bots = [...botList];
    } else {
        const botsJson = await getAllBots();
        bots = botsJson.data.orphan_bots.active;
    }
    botsArray.value = [...populateBots(bots)];
};

const handleSearchBots = (searchQuery) => {
    if (!searchQuery) botsArray.value = populateBots(botList);
    else {
        const filteredBots = botList.filter(
            (item) => !item.heading && item.title.toLowerCase().includes(searchQuery.toLowerCase()),
        );
        botsArray.value = [...populateBots(filteredBots)];
    }
};

const getAgents = async () => {
    if (agentList.length) {
        return agentList;
    }
    try {
        const { uuid: tenantId } = tenantDetails;
        const resp = await AxiosAuth.get(`/get-agent-list/${tenantId}`);

        if (resp.status === 200) {
            agentList = (resp?.data?.data || []).map((agent) => "@" + agent.first_name);
            return agentList;
            // agentsList.value = resp?.data?.data || [];
            // joditConfig.value = {
            //     ...joditConfig.value,
            //     placeholder: "Enter message here ...",
            //     autocomplete: {
            //         insertValueRenderer: (item) => {
            //             const span = document.createElement("strong");
            //             span.style.textDecoration = "underline";
            //             span.innerText = item.value;
            //             return span;
            //         },
            //         itemRenderer: (item) => `
            //                     <div class="inbox_agent_search_list hover:bg-gray-100 p-1.5 rounded-lg">
            //                         <div class="inbox_agent_search_img">
            //                             <img src="${getUserImage()}" alt="${item.title}" />
            //                         </div>

            //                         <span class="inbox_agent_search_text">
            //                         ${item.title}
            //                         </span>
            //                     </div>
            //         `,
            //         sources: [agents],
            //     },
            // };

            // searchedAgentList.value = resp?.data?.data || [];
        }
    } catch (e) {
        console.error("[ERR]: at getAgents", e);
    }
};

//On key press events send message
// const getKeyEventsNote = async (_ev) => {
//     if (_ev.keyCode === 50) {
//         await getAgents();
//     } else {
//         agentsList.value = [];
//     }
// };

let isTyping = false;
let typingTimeout;
const handleKeyPress = (event) => {
    const stoppedTyping = () => {
        socketConn.socket.emit("stop typing", chatroomStore.chatRoom._id);
        isTyping = false;
    };

    if (selectedDropdownOption.value === "reply") {
        if (!isTyping) {
            socketConn.socket.emit("typing", chatroomStore.chatRoom._id);
            isTyping = true;
            clearTimeout(typingTimeout);

            typingTimeout = setTimeout(() => {
                stoppedTyping();
            }, 2500);
        } else {
            clearTimeout(typingTimeout);
            typingTimeout = setTimeout(() => {
                stoppedTyping();
            }, 2500);
        }
    }

    // [info]: do not need it now.
    // if (event.shiftKey && event.key === "Enter") {
    //     if (!isNote) {
    //         const textarea = messageTextArea.value.$el.querySelector("textarea");
    //         const cursorPosition = textarea.selectionStart;
    //         const textBefore = textarea.value.substring(0, cursorPosition);
    //         const textAfter = textarea.value.substring(cursorPosition);
    //         textarea.value = textBefore + "\n" + textAfter;
    //         textarea.selectionStart = cursorPosition + 1;
    //         textarea.selectionEnd = cursorPosition + 1;
    //         adjustTextareaHeight(null, false);
    //         textarea.scrollTop = textarea.scrollHeight;
    //     }
    //     event.preventDefault();
    // } else if (event.key === "Enter" && !event.shiftKey) {
    //     if (isNote) saveNote();
    //     else sendMessage();
    //     event.preventDefault();
    // }
};

// const adjustTextareaHeight = (e, isNote) => {
//     nextTick(() => {
//         if (isNote) {
//             if (noteTextArea.value?.$el) {
//                 const textarea = noteTextArea.value.$el.querySelector("textarea");
//                 if (textarea) {
//                     textarea.style.height = "initial";
//                     textarea.style.height = textarea.scrollHeight + "px";
//                 }
//             }
//         } else {
//             if (messageTextArea.value?.$el) {
//                 const textarea = messageTextArea.value.$el.querySelector("textarea");
//                 if (textarea) {
//                     textarea.style.height = "initial";
//                     textarea.style.height = textarea.scrollHeight + "px";
//                 }
//             }
//         }
//     });
// };

// const getKeyEvents = async (_ev) => {
//     if (timerInstance) {
//         clearTimeout(timerInstance);
//     }
//     await socketConn.socket.emit("typing", chatroomStore.chatRoom._id);
//     timerInstance = setTimeout(() => {
//         socketConn.socket.emit("stop typing", chatroomStore.chatRoom._id);
//     }, 1000);
//     if (_ev.keyCode === 13) {
//         enterButtonClicked++;
//         if (enterButtonClicked === 1) {
//             sendMessage();
//         }
//     }
// };

//Assign Agent to the selected chat room
const assignToRoom = async (flag) => {
    const { uuid: tenantId } = tenantDetails;
    const { _id: chatId } = chatroomStore.chatRoom;
    try {
        await AxiosChat.post("chat/assign-chatroom", {
            userId: agentDetails.agentId,
            chatId,
            tenantId,
            flag,
        });

        // if (resp.status === 200) {
        //     messageStatus.isSend = true;
        // }
    } catch (error) {
        console.error("[ERR]: at assignToRoom", error);
    }
};

//Check if the Agent is already assigned to the selected chat room
const validateAssignment = () => {
    const { users } = chatroomStore.chatRoom;
    const agentIds = users.filter((item) => item.role === "Agent").map((item) => item._id);

    const isAgentAssigned = agentIds.includes(agentDetails.agentId);
    if (isAgentAssigned) return;
    assignToRoom(true);
};

// const sendFile = async (event) => {
//     const files = event.target.files;
//     let contentType = null;
//     const { uuid: tenantId } = tenantDetails;

//     Object.values(files).map((file) => {
//         console.log(file?.type, "file object");
//         if (file.type.includes("image")) contentType = "image";
//         if (
//             file.type.includes("pdf") ||
//             file.type.includes("excel") ||
//             file.type.includes("spreadsheet") ||
//             file.type.includes("msword") ||
//             file.type.includes("document") ||
//             file.type.includes("powerpoint") ||
//             file.type.includes("presentation")
//         )
//             contentType = "document";

//         if (file.type.includes("video")) contentType = "video";
//         if (file.type.includes("audio")) contentType = "audio";
//     });
//     const formData = new FormData();
//     for (let i = 0; i < files.length; i++) {
//         formData.append("content", files[i]);
//         formData.append("mimeType", files[i]?.type);
//     }
//     formData.append("chatId", chatroomStore.chatRoom._id);
//     formData.append("contentType", contentType);
//     formData.append("userId", agentDetails.agentId);
//     formData.append("note", note);
//     formData.append("sentFrom", "Inbox");
//     formData.append("tenantId", tenantId);

//     if (!chatroomStore?.chatRoom?._id || !agentDetails?.agentId) return console.error("roomId && agentId required");

//     const resp = await axios.post(APIURL + `/api/message`, formData, {
//         headers: {
//             "Content-Type": "multipart/form-data",
//         },
//     });
//     if (resp.status === 200) {
//         const chatRoomInfo = resp.data.data;
//         socketConn.socket.emit("new message", chatRoomInfo);
//         chatroomStore.chatRoom = chatRoomInfo?.chat;
//         chatStore.handleFetchAllChats(null, false);
//         // messageStatus.isSend = true;
//         messageInput.value = "";
//         if (resp?.data?.notificationMessage === "You need to assign contacts to get notifications.") {
//             const isRequested = prompt(resp?.data?.notificationMessage);

//             if (isRequested.toLowerCase() === "yes") {
//                 assignToRoom(false);
//             }
//         } else {
//             validateAssignment();
//         }
//     } else {
//         console.error("Unable to send message", resp);
//     }
// };

const SendCannedMessage = (d) => {
    messageInput.value = d;
    sendMessage();
    emits("closeCannedResponse");
    messageInput.value = "";
};

const generatePayloadForMessage = async ({ roomId, isNote, agentId, tenantId, isBot, isEmail }) => {
    if (isBot) {
        const payload = {
            chatroomId: roomId,
            fromUserId: agentId,
            botData: selectedBotDataJson.value,
        };
        return { payload, url: "chat-bot-webhook" };
    }
    let payload = {
        chatId: roomId,
        userId: agentId,
        sentFrom: "Inbox",
        tenantId,
    };

    if (messageAttachments.value.length) {
        const firstFileType = messageAttachments.value[0]?.file.type;
        const isDocument = documentType.some((type) => firstFileType.includes(type));
        const isVideo = firstFileType.includes("video");
        const isAudio = firstFileType.includes("audio");
        const isImage = firstFileType.includes("image");

        const contentType = isDocument ? "document" : isVideo ? "video" : isAudio ? "audio" : isImage ? "image" : null;
        if (!contentType) return null;
        payload.content = messageAttachments.value.map((attachment) => attachment.file);
        payload.mimeType = messageAttachments.value.map((attachment) => attachment.file.type);
        payload.contentType = contentType;
        return { payload: convertJsonToFormData(payload), url: "message" };
    }

    if (isNote) {
        payload.note = convertHTMLIntoMarkdown(messageInput.value);
        payload.content = "dummy_text"; // [info]: required to bypass api validation
        payload.contentType = isNote ? "note" : "text";
    } else if (isEmail) {
        payload.contentType = isEmail ? "email" : "text";
        payload.content = emailInput.value;
        payload.mailData = { subject: emailSubject.value, cc: emailCc.value, bcc: emailBcc.value };
    } else {
        payload.content = convertHTMLIntoMarkdown(messageInput.value);
        payload.contentType = isNote ? "note" : "text";
    }
    return { payload, url: "message" };
};

//Send a message to the selected chat room
const sendMessage = async (isNote = null, isBot = false, isEmail = false) => {
    if (loadingStates.value.sendMessage) return;

    socketConn.socket.emit("stop typing", chatroomStore.chatRoom.users);
    const roomId = chatroomStore.chatRoom._id;
    const agentId = agentDetails.agentId;

    if (
        (messageInput.value.trim() === "" && !messageAttachments.value.length && !isBot && !isEmail) ||
        !roomId ||
        !agentId
    )
        return;
    const { uuid: tenantId } = tenantDetails;

    try {
        loadingStates.value.sendMessage = true;
        const { payload, url } = await generatePayloadForMessage({ roomId, isNote, agentId, tenantId, isBot, isEmail });

        if (!payload) return;
        const resp = await AxiosChat.post(url, payload, {
            useRootBase: isBot,
        });

        if (resp.status === 200) {
            const chatRoomInfo = resp.data.data;

            // [info]: this should be server side
            emits("receiveSendedMessage", formateMessageObject(chatRoomInfo, true));
            socketConn.socket.emit("new message", chatRoomInfo);
            // chatroomStore.chatRoom = chatRoomInfo?.chat;
            chatStore.handleFetchAllChats(null, true);
            // messageStatus.isSend = true;
            sendEmailNotification.isSend = true;
            if (resp?.data?.notificationMessage === "You need to assign contacts to get notifications.") {
                const isRequested = prompt(resp?.data?.notificationMessage, 'Type "yes"');

                if (isRequested.toLowerCase() === "yes") {
                    assignToRoom(false);
                }
            } else {
                validateAssignment();
            }
        }
    } catch (error) {
        console.error("[ERR]: at sendMessage", error);
    } finally {
        loadingStates.value.sendMessage = false;
        selectedBotData.value = {};
        selectedBotDataJson.value = {};
        toPreview.value = false;
        // messageInput.value = "";
        // messageAttachments.value = [];
        await handleOptionClick("reply");
        // noteContent.value = "";
        // openNoteRef.value = false;
        // selectedDropdownOption.value = "reply";
        // openType.value = false;
        // if (messageTextArea.value) {

        nextTick(() => {
            if (joditRef.value) {
                joditRef.value.handleFocus();
            }
            // messageTextArea.value.$el.querySelector("textarea").focus();
        });
        // }
    }
};

const handleCannedFetch = async () => {
    await getCannedResponseList().then((resp) => {
        responseArray.value = [];
        responseArray.value.push({
            heading: true,
            title: "CANNED RESPONSE",
            subnav: [],
        });
        if (resp.data.list.length > 0) {
            for (const x of resp.data.list) {
                responseArray.value.push({
                    title: x.title,
                    id: x.id,
                    detail_info: x.detail_info,
                    subnav: [],
                });
            }
        }
    });
};

const OpenCannedReponse = (d) => {
    emits("ShowCannedReponse", d);
};

//GET a BOT JSON
const getBotJson = async (selectedBotId = null) => {
    const { uuid: tenantId } = tenantDetails;
    if (!tenantId) return;

    loadingStates.value.botJson = true;
    try {
        const resp = await AxiosAuth.post("/get-bot", {
            botId: selectedBotId,
            tenant_uuid: tenantId,
        });

        if (resp.status === 200) {
            return resp?.data?.data;
        }
    } catch (e) {
        console.error("[ERR]: at getBotJson");
    } finally {
        loadingStates.value.botJson = false;
    }
};

const handleBotSelect = async (selectedBotId = null) => {
    toPreview.value = !toPreview.value;

    let botJson = await getBotJson(selectedBotId);
    selectedBotData.value = {
        id: botJson.id,
        name: botJson.name,
        text: botJson.data[1]?.data["modelValText"],
        buttons: botJson.data[1]?.data["actionButtons"],
    };
    selectedBotDataJson.value = botJson;
};
// const roomId = chatroomStore.chatRoom._id;
// const agentId = agentDetails.agentId;
// //Send a BOT message to the selected chat room
// const sendBotMessage = async (selectedBotId = null, chatRoomId = null, chatAgentId = null) => {
//     socketConn.socket.emit("stop typing", chatroomStore.chatRoom.users);
//     const finalRoomId = chatRoomId || roomId;
//     const finalAgentId = chatAgentId || agentId;

//     if (!finalRoomId || !finalAgentId) return console.error("roomId && agentId required");

//     try {
//         let botJson = null;
//         if (selectedBotId) {
//             botJson = await getBotJson(selectedBotId);
//         } else {
//             return console.error("BOT id is required");
//         }

//         const resp = await axios.post(
//             APIURL + `/chat-bot-webhook`,
//             {
//                 chatroomId: finalRoomId,
//                 fromUserId: finalAgentId,
//                 botData: botJson,
//             },
//             {
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//             },
//         );

//         if (resp.status === 200) {
//             const chatRoomInfo = resp.data.data;
//             socketConn.socket.emit("new message", chatRoomInfo);
//             chatroomStore.chatRoom = chatRoomInfo?.chat;
//             // messageStatus.isSend = true;
//             chatStore.handleFetchAllChats(null, true);
//             sendEmailNotification.isSend = true;
//             messageInput.value = "";
//             if (resp?.data?.notificationMessage === "You need to assign contacts to get notifications.") {
//                 const isRequested = prompt(resp?.data?.notificationMessage, 'Type "yes"');

//                 if (isRequested.toLowerCase() === "yes") {
//                     assignToRoom(false);
//                 }
//             } else {
//                 validateAssignment();
//             }
//         } else {
//             console.error("Unable to send message", resp);
//         }
//     } catch (error) {
//         console.error("Unable to send message", error.response);
//     }
// };

watch(
    () => [chatroomStore.chatRoom],
    () => {
        if (joditRef.value) {
            joditRef.value.handleFocus();
        }
    },
);

const agentUser = messenger.getUserByRole("Agent");
const contactUser = messenger.getUserByRole("Contact");
console.log(agentUser, contactUser);

onMounted(() => {
    handleBotFetch();
    /**
     * [info]: setting the custom class for custom positioning of inline options
     */
    document.body.classList.add("jodit-custom-positioning");
    emailFrom.value = agentUser?.userName;
    emailTo.value = contactUser?.email;
});

onUnmounted(() => {
    /**
     * [info]: removing the custom class to it wont effect other places
     */
    document.body.classList.remove("jodit-custom-positioning");
});

// [todo]: fix this
// defineExpose({
//     sendBotMessage,
// });

const emailFrom = ref("ricardo.c@foxtons.estateagents.com");
const emailTo = ref("hn.hassan@gmail.com");
const emailCc = ref("");
const emailBcc = ref("");
const emailSubject = ref("");

const divDisplay = ref({
    cc: false,
    bcc: false,
});

const toggleCCBCC = (div) => {
    divDisplay.value = { ...divDisplay.value, [div]: !divDisplay.value[div] };
};
</script>
<style scoped>
/* [todo]: remove the unused classes */
.box-container {
    /* @apply bg-gray-100; */
    /* display: flex; */
    /* padding: 16px; */
    /* flex-direction: column; */
    /* justify-content: flex-end; */
    /* align-items: flex-start; */
    /* align-self: stretch; */
    width: 100%;
    overflow-y: auto;
    /* max-height: calc(100vh - 350px); */
}

.expand_anim {
    animation: expandToFull 0.5s forwards ease-in-out;
}

.shrunk_anim {
    animation: shrunkToOriginal 0.5s forwards ease-in-out;
}

.full-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
    width: 70vw;
    height: 70vh;
}

@keyframes expandToFull {
    from {
        width: 70vw;
        height: 70vh;
    }
    to {
        width: 100vw;
        height: 100vh;
    }
}

@keyframes shrunkToOriginal {
    from {
        transform: translateY(120%);
    }
    to {
        transform: translateY(0);
    }
}

.select_mode {
    @apply text-sm font-semibold text-black-600;
}
.mode {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}
.message_area {
    width: 100%;
}

.email-container {
    min-height: calc(100vh - 350px) !important;
}

:deep(.message_area textarea) {
    overflow-y: auto;
    max-height: 99%;
    -ms-overflow-style: none;
    scrollbar-width: none;
    /* max-width: 100%;
    width: 100%;
    min-width: 0px;
    margin: 16px 0px;
    outline: none !important;
    height: 100% !important;
    resize: none !important;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal; */
    /* max-height: calc(100vh - 350px); */
    /* overflow-y: auto; */
}

:deep(.message_area textarea::-webkit-scrollbar) {
    display: none;
}

.message_area textarea::placeholder {
    @apply text-gray-500;
    /* Small button */
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}
.options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    @apply mt-auto;
}
.mode > svg {
    color: #c5c7d1;
    font-family: "Font Awesome 6 Pro";
    font-size: 24px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
}
.option-icons {
    line-height: 20px;
    position: relative;
    display: flex;
}
.option-icons svg {
    vertical-align: top;
}
.note-container {
    @apply bg-[#FEF9BC] justify-start;
}
.note-container textarea {
    @apply bg-[#FEF9BC];
}

.mentions-list {
    @apply mt-1 bg-white rounded-lg shadow-lg;
}

.mention-item {
    @apply px-4 py-2 hover:bg-gray-100 cursor-pointer;
}

.mention-item span {
    @apply text-sm text-gray-600;
}

@media only screen and (max-width: 574px) {
    .box-container {
        @apply !rounded-none;
    }
    .full-container {
        border-radius: 8px !important;
        height: calc(100vh - 215px) !important;
    }
}

/* [info]: copied these from SelectAssignedContact */
.assigned-dropdown {
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
    z-index: 2;
    padding: 10px;
    width: fit-content;
}

.app_search {
    @apply relative;
}

.bg_white + .app_search_result .app_search_result__item {
    @apply bg-white dark:bg-gray-500;
}

.bg_white input,
.bg_white .app_search_single {
    @apply bg-white dark:bg-gray-500 text-dark-200 dark:text-white;
}

.bg_white .app_search_dropdown {
    @apply bg-white dark:bg-gray-500 text-dark-200 dark:text-white;
}
.email_signature_text a,
.email_signature_text {
    @apply text-[#525252] text-xs leading-[14px];
    font-family: Helvetica, sans-serif;
}
/* [info]: for jodit */
:deep(.jodit-container) {
    background-color: transparent !important;
    border: none !important;
    outline: none !important;
    min-height: auto !important;
}

:deep(.jodit-container:not(.jodit_inline) .jodit-workplace) {
    background-color: transparent !important;
    border: none;
    outline: none;
    min-height: auto !important;
}

:deep(.jodit-container:not(.jodit_inline) .jodit-workplace > :first-child) {
    min-height: auto !important;
    @apply text-sm px-0 leading-[17px];
}
:deep(.jodit-wysiwyg) {
    padding: 0 !important;
}
</style>
